// src/contexts/ToastContext.js

import React, { createContext, useState, useCallback } from "react";
import PropTypes from "prop-types";
import Toast from "../components/Common/Toast";
import { v4 as uuidv4 } from 'uuid'; // Install uuid via npm

export const ToastContext = createContext();

/**
 * ToastProvider manages toast notifications and provides functions to add and remove toasts.
 */
export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  /**
   * Adds a new toast notification.
   * @param {string} message - The message to display.
   * @param {string} type - The type of toast ('info', 'success', 'error').
   */
  const addToast = useCallback((message, type = "info") => {
    const id = uuidv4(); // Generate a unique ID for each toast
    setToasts((prevToasts) => [...prevToasts, { id, message, type }]);
  }, []);

  /**
   * Removes a toast notification by ID.
   * @param {string} id - The ID of the toast to remove.
   */
  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      {children}
      {/* Toast Container */}
      <div className="fixed top-20 right-5 flex flex-col space-y-2 z-50">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            onClose={() => removeToast(toast.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
